import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import SettingsIcon from '@material-ui/icons/Settings';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import { withTheme } from '@rjsf/core';
import { Theme } from '@rjsf/material-ui';
import validator from '@rjsf/validator-ajv8';

const Form = withTheme(Theme);
const useStyles = makeStyles(
  (theme) => createStyles({
    iconGrid: {
      height: "100%",
      "& *": {
        padding: 0
      }
    },
    settingsOverlay: {
      position: "absolute",
      backgroundColor: "rgba(40, 40, 40, 0.93)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      padding: theme.spacing(2),
      color: "white"
    }
  })
);
const WidgetSettingsOverlay = (props) => {
  const { id, widget, settings, handleRemove, handleSettingsSave, deletable } = props;
  const [settingsDialogOpen, setSettingsDialogOpen] = React.useState(false);
  const styles = useStyles();
  return /* @__PURE__ */ React.createElement("div", { className: styles.settingsOverlay }, widget.settingsSchema && /* @__PURE__ */ React.createElement(
    Dialog,
    {
      open: settingsDialogOpen,
      className: "widgetSettingsDialog",
      onClose: () => setSettingsDialogOpen(false)
    },
    /* @__PURE__ */ React.createElement(DialogContent, null, /* @__PURE__ */ React.createElement(
      Form,
      {
        validator,
        showErrorList: false,
        schema: widget.settingsSchema,
        uiSchema: widget.uiSchema,
        noHtml5Validate: true,
        formData: settings,
        formContext: { settings },
        onSubmit: ({ formData, errors }) => {
          if (errors.length === 0) {
            handleSettingsSave(id, formData);
            setSettingsDialogOpen(false);
          }
        },
        experimental_defaultFormStateBehavior: {
          allOf: "populateDefaults"
        }
      }
    ))
  ), /* @__PURE__ */ React.createElement(
    Grid,
    {
      container: true,
      className: styles.iconGrid,
      alignItems: "center",
      justifyContent: "center"
    },
    widget.settingsSchema && /* @__PURE__ */ React.createElement(Grid, { item: true, className: "overlayGridItem" }, /* @__PURE__ */ React.createElement(Tooltip, { title: "Edit settings" }, /* @__PURE__ */ React.createElement(
      IconButton,
      {
        color: "primary",
        onClick: () => setSettingsDialogOpen(true)
      },
      /* @__PURE__ */ React.createElement(SettingsIcon, { fontSize: "large" })
    ))),
    deletable !== false && /* @__PURE__ */ React.createElement(Grid, { item: true, className: "overlayGridItem" }, /* @__PURE__ */ React.createElement(Tooltip, { title: "Delete widget" }, /* @__PURE__ */ React.createElement(IconButton, { color: "secondary", onClick: () => handleRemove(id) }, /* @__PURE__ */ React.createElement(DeleteIcon, { fontSize: "large" }))))
  ));
};

export { WidgetSettingsOverlay };
//# sourceMappingURL=WidgetSettingsOverlay.esm.js.map
